import React from 'react'
import { PrismicRichText } from '@prismicio/react'

const Text = ({ slice }) => {
  return (
    <section className='component-text relative mx-auto max-w-screen-xl py-3 px-4'>
      <div className='prose min-w-full'>
        <PrismicRichText field={slice.primary.text.richText} />
      </div>
    </section>
  )
}

export default Text
